import api from '../../plugins/api';

// ÐÐ°ÐºÑÑÐ²Ð°ÐµÑ Ð¿ÑÐ¸ÑÐ¼: ÑÑÑÐ»ÐºÐ° ÑÐ´ÐµÐ»ÐºÐ¸ Ð¿ÐµÑÐµÑÑÐ°ÑÑ ÑÐ°Ð±Ð¾ÑÐ°ÑÑ, Ð¿ÑÐ¸ÑÐ»Ð°Ð½Ð½ÑÐµ ÑÐ°Ð¹Ð»Ñ Ð¾ÑÑÐ°ÑÑÑÑ.
const revokeClientUploadLink = ({ dealId }) => {
  return api.post('/api/crm/clientUpload/revoke', { dealId });
};

export default revokeClientUploadLink;
